// src/services/personalPageService.js
import { fetchWithAuth } from "./apiService";
import { getApiUrl } from "../services/api";

const BASE_URL = "api/PersonalPage";

/**
 * Профиль пользователя (AllowAnonymous на бэке).
 * Возвращает объект профиля или кидает ошибку.
 */
export const fetchUserProfile = async (userId) => {
    if (!userId) throw new Error("User ID не может быть пустым.");

    return await fetchWithAuth(
        getApiUrl(`${BASE_URL}/users/${encodeURIComponent(userId)}/profile`),
        {
            method: "GET",
        }
    );
};

export const fetchMyProfile = async () => {
    return await fetchWithAuth(
        getApiUrl(`${BASE_URL}/me/profile`),
        {
            method: "GET",
        }
    );
};

/**
 * Книги пользователя (Authorize на бэке).
 * Бэк возвращает 404, если книг нет. Преобразуем 404 в пустой массив.
 */
export const fetchUserBooks = async (userId) => {
    if (!userId) throw new Error("User ID не может быть пустым.");

    try {
        return await fetchWithAuth(
            getApiUrl(`${BASE_URL}/users/${encodeURIComponent(userId)}/books`),
            {
                method: "GET",
            }
        );
    } catch (err) {
        if (err?.status === 404) return [];
        throw err;
    }
};

/**
 * Загрузка аватара (Authorize).
 * Форм-данные: Content-Type вручную не ставим.
 */
export const uploadProfilePicture = async (profilePicture) => {
    if (!profilePicture) throw new Error("Файл изображения не передан.");

    const formData = new FormData();
    formData.append("ProfilePicture", profilePicture);

    return await fetchWithAuth(getApiUrl(`${BASE_URL}/me/avatar`), {
        method: "PUT",
        body: formData,
    });
};

/**
 * Обновление пола (Authorize).
 */
export const updateUserGender = async (gender) => {
    if (!gender) throw new Error("Пол не может быть пустым.");

    return await fetchWithAuth(getApiUrl(`${BASE_URL}/me/gender`), {
        method: "PUT",
        body: JSON.stringify({ gender }),
    });
};

/**
 * Обновление настройки личных сообщений (Authorize).
 */
export const updateMessagesOnlyFromFriends = async (messagesOnlyFromFriends) => {
    return await fetchWithAuth(getApiUrl(`${BASE_URL}/me/message-settings`), {
        method: "PUT",
        body: JSON.stringify({ messagesOnlyFromFriends }),
    });
};
